const badges = [
  {color: "#F6C042", text: "Comprando"},
  {color: "#E74C3C", text: "Ocupado"},
  {color: "#3498DB", text: "Seleccionado"},
  {color: "#2ECC71", text: "Disponible"},
  {color: "#9B59B6", text: "Abonado"},
];

const SeatsBadges: React.FC = () => {
  return (
    <div className="flex justify-center space-x-4 overflow-x-auto">
      {badges.map((badge, index) => (
        <div key={index} className="flex items-center gap-2">
          <div
            className="w-6 h-6 rounded-full"
            style={{backgroundColor: badge.color}}
          ></div>
          <span>{badge.text}</span>
        </div>
      ))}
    </div>
  );
};

export default SeatsBadges;
